"use strict";

import angular from "angular";

import template from "./header-top-nav.component.html";
import "./themes/header-top-nav.component.scss";

import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { ConsultiveAccessService } from "../../../presentation/services/ConsultiveAccessService";
import { HomeRedirectService } from "../../../presentation/services/HomeRedirectService";
import { CompanyStatusChange } from "../../../presentation/services/CompanyStatusChange";
import { isInactiveCompany } from "../../../entity/company-license";
import { companyDocumentLabel } from "../../../utils/format/format";
import { GROUP_COMPANIES_SIDENAV_ID } from "../group-companies-sidenav/group-companies-sidenav.component";

export class HeaderTopNavComponent {
    constructor(
        $scope,
        $state,
        $stateParams,
        $rootScope,
        LayoutService,
        UserProfileSidenavService,
        CompanyDataService,
        DSNDialogService,
        $mdDialog,
        $mdSidenav
    ) {
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;

        this.LayoutService = LayoutService;
        this.UserProfileSidenavService = UserProfileSidenavService;
        this.CompanyDataService = CompanyDataService;
        this.DSNDialogService = DSNDialogService;
        this.$mdDialog = $mdDialog;
        this.$mdSideNav = $mdSidenav;

        this.user = new UserDataAdapter().user();
    }

    $onInit() {
        this.$rootScope.$on(
            "SET_NANDA_NOTIFICATION",
            (event, status, scope) => {
                this.onReceiveNotification(event, status, scope);
                this.$scope.$applyAsync();
            }
        );
    }

    /**
     * Fechar sai para a casa da contabilidade.
     *
     * Com Agente Consultivo, a casa é a Central Consultiva no V2, e o grupo vai pelo mesmo
     * caminho de todas as outras telas — o desvio antigo para `overview.portfolio.groups.resume`
     * devolvia o usuário a uma tela que não é mais a casa dele.
     *
     * Sem Agente Consultivo a casa continua no V1, e aí o desvio do grupo faz sentido de novo:
     * fechar um grupo volta para a carteira de grupos.
     */
    goToOverview() {
        const accountingId = this.getAccountingId();

        if (this.isBusinessman()) {
            this.$state.go(
                "nucont.accounting.overview.portfolio.companies.register",
                { accountingId }
            );
            return;
        }

        if (!ConsultiveAccessService.peek()) {
            const isGroup = this.$state.current.name.indexOf("group") >= 0;
            return this.$state.go(
                isGroup
                    ? "nucont.accounting.overview.portfolio.groups.resume"
                    : "nucont.accounting.overview.portfolio.companies.resume",
                { accountingId }
            );
        }

        HomeRedirectService.go({ accountingId, hasAccess: true });
    }

    /**
     * O cabeçalho está mostrando o nome de um GRUPO que já tem as empresas-membro carregadas.
     *
     * A lista vem do resolve do estado do grupo (`group.routes.js` publica em `$rootScope.company`)
     * — sem ela o nome continua sendo texto, porque o painel não teria o que listar.
     */
    hasGroupCompanies() {
        const company = this.$rootScope.company;
        return Boolean(company?.isGroup && company?.companies?.length);
    }

    onOpenGroupCompanies() {
        if (!this.hasGroupCompanies()) return;
        this.$mdSideNav(GROUP_COMPANIES_SIDENAV_ID).open();
    }

    isBusinessman() {
        return this.user?.roles?.includes("Empresa") || false;
    }

    /**
     * Selo "Inativa" ao lado do nome da empresa — o mesmo da linha da Central no v2.
     *
     * É um RÓTULO: não tranca nada, não recorta lista, só informa que a empresa ainda não foi
     * ativada. O menu está inteiro aberto, e o que a licença muda é o dashboard borrado e a escrita
     * barrada. Clicar no selo abre o diálogo de licença, que é onde a situação se resolve.
     *
     * O título do cabeçalho também é usado por grupo e por outras telas; a URL `/empresa/` é o que
     * separa "estou dentro de uma empresa" do resto.
     */
    isCompanyInactive() {
        if (!this.LayoutService.headerConfig?.title?.enabled) return false;
        if (!/\/empresa\//.test(window.location.pathname)) return false;
        return isInactiveCompany(this.CompanyDataService.get()?.props);
    }

    getCompanyDocumentLabel() {
        if (!/\/empresa\//.test(window.location.pathname)) return "";
        return companyDocumentLabel(
            this.CompanyDataService.get()?.props?.document
        );
    }

    onActivateCompany($event) {
        const company = this.CompanyDataService.get();
        if (!company) return;

        const companyStatusChange = new CompanyStatusChange({
            DSNDialogService: this.DSNDialogService,
            $mdDialog: this.$mdDialog,
            accountingId: this.getAccountingId()
        });

        companyStatusChange.execute(
            {
                $event,
                company: {
                    _id: company.props._id,
                    status: company.props.status
                }
            },
            ({ status }) => {
                // O dashboard borrado e a escrita barrada dependem deste status: sem atualizar a
                // entidade em memória, ativar deixaria a empresa ativa no banco e a tela embaçada
                // até o próximo F5.
                this.CompanyDataService.setAttribute("status", status);
                this.$scope.$applyAsync();
            }
        );
    }

    getAccountingId() {
        return (
            this.$stateParams.accIdReference ||
            this.$state.params.accIdReference ||
            this.$stateParams.accountingId ||
            this.$state.params.accountingId
        );
    }

    onReceiveNotification(event, status, scope) {}

    onIndicateAndWin() {
        window.open("https://pages.nucont.com/indicacao", "_blank");
    }

    isIndiqueGanheVisible() {
        const currentState = this.$state.current.name;
        return (
            currentState.indexOf("nucont.accounting.overview.dashboard") > -1 ||
            currentState.indexOf("nucont.accounting.overview.portfolio") > -1
        );
    }
}

HeaderTopNavComponent.$inject = [
    "$scope",
    "$state",
    "$stateParams",
    "$rootScope",
    "LayoutService",
    "UserProfileSidenavService",
    "CompanyDataService",
    "DSNDialogService",
    "$mdDialog",
    "$mdSidenav"
];

const name = "headerTopNavComponent";
const def = {
    controller: HeaderTopNavComponent,
    bindings: {},
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
